module.exports = __webpack_public_path__ + "img/12cm.c9813d9a.jpg";